import { YouTubeIframe } from '../../../@vendor/YouTubeIframe';
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { component, property } from '../../../concepts/objects';
import { Physical, PotentialInteraction } from '../../canvas/entities/Physical';
import { RectangularPhysical } from '../../canvas/entities/RectangularPhysical';
import { Resizable } from '../../canvas/entities/Resizable';
import { Snappable } from '../../canvas/entities/Snappable';
import { VideoController } from './VideoController';

const invocation = defineCommand(
    'youTubeVideoInvoke',
    'YouTubeVideo Invoke',
    (r, [id]: [string]) => {
        r.call(VideoController).playOrStop(id);
    },
    [],
);

const youTubeVideoDef = {
    name: 'YouTubeVideo',
    // mutation: graphicMutate,
    invocation,
    implements: [Physical, Resizable, Snappable]
};

@component(youTubeVideoDef)
export class YouTubeVideo extends RectangularPhysical implements Snappable {

    private cachedPlayer = null as YT.Player;

    public get boundary() {
        return true;
    }

    public get shouldSnap() {
        return true;
    }

    @property({ type: 'string' })
    public videoId!: string;

    public async getPlayer() {
        if (this.cachedPlayer) return Promise.resolve(this.cachedPlayer);
        return new Promise<YT.Player>((rs) => {
            YouTubeIframe.init().then(() => {
                const elmt = document.querySelector(`[data-video-src="${this.id}"]`) as HTMLIFrameElement;
                const player = new YT.Player(elmt, {
                    events: {
                        onReady: () => {
                            this.cachedPlayer = player;
                            rs(player);
                        }
                    }
                });
            });
        });
    }

    public testInteraction({ type, mpt }: PotentialInteraction): [boolean, string] {
        if (this.localBounds.contains(this.toRelative(mpt))) {
            return [true, 'default'];
        }
        return [false, 'none'];
    }

}

